import firebase from 'firebase/app';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyD16Xc67za35ntVfafLGDY7etSovTycyN4',
  authDomain: 'renablog-106da.firebaseapp.com',
  databaseURL: 'https://renablog-106da.firebaseio.com',
  projectId: 'renablog-106da',
  storageBucket: 'renablog-106da.appspot.com',
  messagingSenderId: '894680876981',
  appId: '1:894680876981:web:46062723bfc909df',
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
